/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkMetadata
 */
export interface LinkMetadata {
    /**
     * 
     * @type {string}
     * @memberof LinkMetadata
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof LinkMetadata
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkMetadata
     */
    srcUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkMetadata
     */
    caption?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkMetadata
     */
    url: string;
}

/**
 * Check if a given object implements the LinkMetadata interface.
 */
export function instanceOfLinkMetadata(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function LinkMetadataFromJSON(json: any): LinkMetadata {
    return LinkMetadataFromJSONTyped(json, false);
}

export function LinkMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'srcUrl': !exists(json, 'src_url') ? undefined : json['src_url'],
        'caption': !exists(json, 'caption') ? undefined : json['caption'],
        'url': json['url'],
    };
}

export function LinkMetadataToJSON(value?: LinkMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'description': value.description,
        'src_url': value.srcUrl,
        'caption': value.caption,
        'url': value.url,
    };
}

